// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__d7dQ8","active":"Menu_active__fcOKs","logout":"Menu_logout__7naPs","close-menu":"Menu_close-menu__Vzk8l","backdrop":"Menu_backdrop__LkF4g"};